import { observable, action } from 'mobx'
import api from '../api'

class ChangePasswordStore {
  @observable password = ''
  @observable passwordRepeat = ''
  @observable passwordMessage

  @action.bound setPassword(password) {
    this.password = password
  }

  @action.bound setPasswordRepeat(passwordRepeat) {
    this.passwordRepeat = passwordRepeat
  }

  @action.bound async sendPassword(confirmId) {
    try {
      return await api.User.setPassword(confirmId, this.password)
        .then(res => res)
    } catch(error) {
    }
  }
}

export default new ChangePasswordStore()



// WEBPACK FOOTER //
// ./src/stores/changePasswordStore.js